
import { h, render, Fragment } from 'https://unpkg.com/preact@latest?module';
import { useCallback } from 'https://unpkg.com/preact@latest/hooks/dist/hooks.module.js?module';
import htm from 'https://unpkg.com/htm?module';

import PhotoSwipeLightbox from 'https://unpkg.com/photoswipe@beta/dist/photoswipe-lightbox.esm.js';
import PhotoSwipeDynamicCaption from './casper-module-lib.js';

// Initialize htm with Preact
const html = htm.bind(h);

function Grid({ images, texts }) {
    const textViews = texts.map((item) => (<p dangerouslySetInnerHTML={{ __html: item.p.outerHTML }}></p>));
    const imageViews = images.map((item) => (<Image data={item} />));

    return (
        <Fragment>
            {textViews}
            <div id="grid-photo">
                {imageViews}
            </div>
        </Fragment>
    );
};

function Image(props) {
    const { image, caption } = props.data;
    const processCaption = useCallback(() => {
        try {
            return caption.split("###").map((d, i) => {
                if (i == 0) return <b>{d.trim()}</b>
                else return (<Fragment><br />{d.trim()}</Fragment>)
            });
        } catch (ex) { }
    }, caption);

    return (
        <div class="photo-item">
            <a class="photo-cnt"
                target="_blank"
                href={image.src} dangerouslySetInnerHTML={{ __html: image.outerHTML }}
                data-pswp-width={image.attributes["width"].value}
                data-pswp-height={image.attributes["height"].value}
            />
            <div class="pswp-caption-content">
                {processCaption()}
            </div>
        </div>
    );
}

const smallScreenPadding = {
    top: 0, bottom: 0, left: 0, right: 0
};
const largeScreenPadding = {
    top: 30, bottom: 30, left: 0, right: 0
};
const lightbox = new PhotoSwipeLightbox({
    gallery: '#grid-photo',
    children: '.photo-item',
    // optionaly adjust viewport
    paddingFn: (viewportSize) => {
        return viewportSize.x < 700 ? smallScreenPadding : largeScreenPadding
    },
    pswpModule: () => import('https://unpkg.com/photoswipe@beta/dist/photoswipe.esm.js')
});

const captionPlugin = new PhotoSwipeDynamicCaption(lightbox, {
    mobileLayoutBreakpoint: 700,
    type: 'auto',
    mobileCaptionOverlapRatio: 1
});

const onAppReady = function () {
    const divRender = HTML.query("#custom-render");

    // return list of:
    const images = [];
    const texts = [];

    // {p: pNode}
    const sourceView = HTML.query("#custom-content");
    try {
        sourceView.p.each(function (el, i, all) {
            texts.push({
                p: el
            });
        });
    } catch (ex) { }

    // {image: imageNode, caption: "caption"}
    try {
        sourceView.figure.each(function (el, i, all) {
            let caption = ""
            if (el.figcaption) {
                caption = el.figcaption.textContent;
            }
            images.push({
                image: el.img,
                caption: caption
            });
        });
    } catch (ex) { }

    render(<Grid images={images} texts={texts} />, divRender);

    FlexMasonry.init("#grid-photo", {
        responsive: true,
        breakpointCols: {
            'min-width: 1500px': 2,
            'min-width: 1200px': 2,
            'min-width: 992px': 2,
            'min-width: 768px': 2,
            'min-width: 576px': 1,
        }
    });

    lightbox.init();
};

(function (window, document) {
    document.addEventListener('DOMContentLoaded', function () {
        try {
            onAppReady();
        } catch (ex) { }
    });
})(window, document);
